import Modal from './modal';
import Portal from './portal';
import { ConfigProvider } from 'antd';

import { FC, useEffect, useState } from 'react';
import type { ModalProps } from './modal';


export interface ModalWrapProps extends ModalProps {
  destroyOnClose?: boolean;
}

const ModalWrap: FC<ModalWrapProps> = (props) => {

  const {  destroyOnClose = false, ...modalProps } = props;

  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (!shouldRender && props.isOpen) {
      setShouldRender(true)
    }
  }, [props.isOpen, shouldRender])

  const afterClose = () => {
    props.afterClose && props.afterClose();
    if (destroyOnClose) {
      setShouldRender(false)
    }
  }

  if (typeof window !== 'undefined') {
    const buttonTheme: any = { };
    const omsConfig: any = window?.__WEB_SITE_APP_CONFIG?.appConfig || {};
    if (omsConfig?.themeTextColor) {
      buttonTheme.primaryColor = omsConfig?.themeTextColor;
      buttonTheme.colorTextLightSolid = omsConfig?.themeTextColor;
    }
    return (
      <Portal open={shouldRender} container={document.body}>
        <ConfigProvider wave={{disabled: true}} theme={
          { 
            token: window?.__WEB_SITE_APP_CONFIG?.antdToken || {},
            components: {
              Button: buttonTheme,
            }
          }
        }>
          <Modal {...modalProps} afterClose={afterClose} />
        </ConfigProvider>
      </Portal>
    )
  }

  return null;
}

export default ModalWrap;

